module.exports = __webpack_public_path__ + "img/سربرگ عمودی.b58840a8.png";